/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{padding-top:40px;padding-left:5%;padding-right:5%;background:linear-gradient(to bottom,#e9ecef,transparent) top no-repeat;background-size:100% 50px}"];
export { styles as styles };
